import { render, staticRenderFns } from "./DialogOrder.vue?vue&type=template&id=c9bbbc66&scoped=true&"
import script from "./DialogOrder.vue?vue&type=script&lang=js&"
export * from "./DialogOrder.vue?vue&type=script&lang=js&"
import style0 from "./DialogOrder.vue?vue&type=style&index=0&id=c9bbbc66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bbbc66",
  null
  
)

export default component.exports